// extracted by mini-css-extract-plugin
export default {"root":"HorizontalSpace_root__Gsiud"};